import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/providers/freee/companies`

const tenantProviderCompany = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve()
        } )
      })
    }
  },
}
export default tenantProviderCompany
